// extracted by mini-css-extract-plugin
export var content = "removeWarehouseModal-module--content--b7e20";